<template>
    <div>关于我们</div>
</template>

<script>
    export default {
        name: "aboutus"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/aboutus.vue